<td ng-class='highlightClass(projectNote.created, projectNote.updated);' 
    style='vertical-align: top;white-space:nowrap;font-style:italic;'>
    {{projectNote.noteDate | date:'MMM yyyy'}}
</td>
<td>
    <i *ngIf="showMemberNoteControls"
       class='fa fa-pencil-square-o fa-lg'
       style='color:blue;cursor:pointer;'
       (click)='openUpdateMemberNoteDialog(projectNote)'
       title='edit this note...'>
    </i>
</td>
<td>
    <div [ngClass]='highlightService.class(projectNote.created, projectNote.updated)'  
         style='font-style:italic;' 
         [innerHTML]='projectNote.note | highlight: searchTerm'>
    </div>
    <div style='font-size:11px;'>
        <span style='font-weight:bold;'>created by:</span> 
        {{projectNote.createdBy}} {{projectNote.created | date:'dd MMM yyyy'}} &nbsp;&nbsp;&nbsp;
        <span *ngIf='projectNote.updated > projectNote.created'>
            <span style='font-weight:bold;'>updated by:</span>
            {{projectNote.updatedBy}} {{projectNote.updated | date:'dd MMM yyyy'}}
        </span>
    </div>
</td>
<td style='vertical-align: top;white-space:nowrap;'>
    <ul class='list-unstyled ' *ngFor='let noteType of projectNote.noteTypes'>
        <li [ngClass]='highlightService.class(noteType.created, noteType.created)'  style='font-style:italic;'>
            {{noteType.noteType}}
        </li>
    </ul>
</td>
<td>
    <i *ngIf="showMemberNoteControls"
       class='fa fa-times-circle fa-lg no-print'
       style='color:red;margin-top:4px;cursor:pointer;'
       (click)='openDeleteMemberNoteDialog(projectNote)'
       title='delete this note...'></i>
</td>


